export const docType = {
  subpoena: 0,
  local: 1,
  template: 2
}

export const requestType = {
  local: 1,
  template: 2
}

export const memberType = {
  individual: 0,
  legal: 1,
  official: 2
}

export const queryTypes= {
  automation: 0,
  template: 1
}